import styled, { css } from 'styled-components';
import { space } from 'styled-system';
import IconStyles from '../base/iconStyles';
import TypographyStyles from '../base/typographyStyles';

const ImageSetItemStyles = styled.div`
  ${space}

  position: relative;
  padding: ${props => props.theme.space[1]};
  cursor: pointer;

  ${TypographyStyles.HeadingStyles} {
    margin-top: ${props => props.theme.space[1]};
    text-transform: none;
    text-align: center;
  }

  ${IconStyles} {
    position: absolute;
    right: 0.75rem;
    top: 0.75rem;
  }

  &::before {
    content: '';
    display: block;
    top: ${props => props.theme.space[1]};
    left: ${props => props.theme.space[1]};
    right: ${props => props.theme.space[1]};
    bottom: ${props => props.theme.space[1]};
    border: 0.125rem solid ${props => props.theme.colors.primary};
    position: absolute;
    opacity: 0;
    transition: 0.2s linear opacity;
  }

  &:hover {
    &::before {
      opacity: 1;
    }
  }

  ${props =>
    props.selected &&
    css`
      &::before {
        opacity: 1;
      }
    `};
`;

const ImageSetStyles = styled.div`
  ${space}

  margin-left: -${props => props.theme.space[1]};
  margin-right: -${props => props.theme.space[1]};

  ${props =>
    props.mt === undefined &&
    css`
      margin-top: ${props.theme.space[1]};
    `};

  ${props =>
    props.mb === undefined &&
    css`
      margin-bottom: -${props.theme.space[1]};
    `};

  display: flex;
  flex-wrap: wrap;
  width: calc(100% + ${props => props.theme.space[2]});
  position: relative;

  ${props =>
    props.itemsInRow !== undefined &&
    css`
      ${ImageSetItemStyles} {
        width: calc(100% / ${props.itemsInRow});
      }
    `};
`;

ImageSetStyles.ItemStyles = ImageSetItemStyles;

export default ImageSetStyles;
